import { TUseGlobalVariables } from '@libs/types';

declare const INIT_VARIABLES: Record<string, unknown>;

export const getGlobalVariables = (...variableNames: string[]): TUseGlobalVariables => {
    const globals = INIT_VARIABLES ?? {};

    const variables = variableNames.reduce(
        (accumulator, name) => {
            accumulator[name] = globals[name] as string;
            return accumulator;
        },
        {} as Record<string, string>,
    );

    return Object.freeze(variables);
};
